// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"273ac989","239":"7d45f016","455":"59902b38"}[chunkId] + ".chunk.js";
};